import m from "../../geodata/es2015/romaniaHigh";
window.am4geodata_romaniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/romaniaHigh.js
// module id = null
// module chunks = 